<template>
  <div>
    <el-tabs value="tab_user" type="border-card" v-model="activeName">
      <el-tab-pane label="财务中心" name="tab_user">
        <el-form ref="form" :model="formQuery" inline size="mini">
          <el-form-item>
            <el-date-picker
                v-model="formQuery.daterange"
                :picker-options="pickerOptions"
                type="datetimerange"
                range-separator="-"
                start-placeholder="Start date"
                end-placeholder="End date">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery">查询</el-button>
            <el-button type="primary" @click="handleExport">导出总订单数据</el-button>
          </el-form-item>
        </el-form>

        <el-card>
          <el-table :data="saleEntityList" size="mini">
            <el-table-column label="销售渠道" prop="keyName" width="200"/>
            <el-table-column label="完成单数" prop="finishCount" width="150"/>
            <el-table-column label="总金额" prop="finishAmt" width="150"/>
            <el-table-column label="总退款" prop="refundAmt" width="150"/>
            <el-table-column label="实收" prop="amt" width="150"/>
          </el-table>
        </el-card>

        <el-table :data="orderPackList" size="mini">
          <el-table-column type="expand" fixed="left">
            <template v-slot:="props">
              <vue-json-editor v-model="props.row" :showBtns="true"></vue-json-editor>
            </template>
          </el-table-column>
          <el-table-column label="总订单ID" prop="_id" width="180"/>
          <el-table-column label="第三方账单号" prop="billno" width="150"/>
          <el-table-column label="销售渠道" prop="saleEntity" width="100"/>
          <el-table-column label="子订单数" prop="orderLength" width="80"/>
          <el-table-column label="支付方式" width="80">
            <template v-slot:="scope">
              <div>
                {{ getPayTypeDesc(scope.row.payType) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="入账金额" prop="finishAmt" width="80"/>
          <el-table-column label="退款金额" prop="refundAmt" width="80"/>
          <el-table-column label="实收" prop="amt" width="80"/>
          <el-table-column prop="createdAt" label="创建时间" width="230">
            <template v-slot="scope">
              <div>
                {{ moment(scope.row.createdAt).tz(defaultTimeZone).toISOString(true) }}
              </div>
            </template>
          </el-table-column>

        </el-table>
        <Pagination ref="pagination" @change="onPageChange"></Pagination>

      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import * as _ from 'lodash';
import VueJsonEditor from '@/components/VueJsonEditor'
import Pagination from '@/components/Pagination'
import moment from "moment-timezone"
import {
  getSaleEntity,
  getPaymentStateTagInfo,
  pickerOptions,
} from '@/utils'
import {getPayTypeDesc, PaymentState, defaultTimeZone} from '@/utils/constants'

export default {
  components: {VueJsonEditor, Pagination},
  data() {
    return {
      activeName: 'tab_user',
      formQuery: {
        daterange: [moment("0", "hh").toISOString(), moment("24", "hh").toISOString()],
      },

      // 渠道统计列表
      saleEntityList: [],
      orderPackList: [],

      pickerOptions,
      defaultTimeZone,
      moment,
      getPayTypeDesc,
      getPaymentStateTagInfo,
    };
  },
  created() {
    this.current_app = this.$store.state.app
  },

  computed: {
    cur_app() {
      return this.$store.state.app;
    }
  },
  watch: {
    $route(to) {
      if (this.current_app === this.$store.state.app) {
        return
      }
    }
  },
  methods: {

    queryOrderPack(limit, offset) {
      const daterange = this.formQuery.daterange;
      if (!daterange) {
        this.$message.warning('查询统计数据，需要输入时间');
        return
      }
      this.$axios.post('/payment/order/pack/list', {daterange, limit, offset, state: PaymentState.Created}).then(res => {
        this.$message.info('查询成功');
        this.orderPackList = res.orderPackList;
        let saleEntityMap = {};
        this.orderPackList.forEach(item => {
          const productPremium = item.product.extra.premium;
          item['finishAmt'] = productPremium * item.idList.length;
          item['orderLength'] = item.idList.length;
          const orderList = item.orderList;
          if (orderList.length <= 0) item['refundAmt'] = 0
          else item['refundAmt'] = orderList.filter(item => {
            return item.state === PaymentState.Refund
          }).length * productPremium;
          item['amt'] = item['finishAmt'] - item['refundAmt'];
          
          const saleEntity = getSaleEntity(0,0, item.product.baosiId);
          item['saleEntity'] = saleEntity;
          if(!saleEntityMap[saleEntity]) saleEntityMap[saleEntity] = {
            keyName: saleEntity,
            finishAmt: 0,
            finishCount: 0,
            refundAmt: 0
          }
          saleEntityMap[saleEntity].finishAmt += item['finishAmt'];
          saleEntityMap[saleEntity].finishCount += 1;
          saleEntityMap[saleEntity].refundAmt += item['refundAmt'];
        })
        this.saleEntityList = _.map(saleEntityMap, (value, key) => {
          return {
            ...value,
            amt: value['finishAmt'] - value['refundAmt'],
          }
        })
        this.$refs.pagination.setTotal(res.count)
        if(offset === 0) {
          this.$refs.pagination.setCurPage(1)
        }
      }).catch(res => {
        this.logining = false;
      })
    },

    onPageChange(pageSize, currentPage) {
      this.queryOrderPack(pageSize, (currentPage - 1) * pageSize)
    },

    handleQuery() {
      this.queryOrderPack(this.$refs.pagination.getSize(), 0)
    },

    handleExport() {
      const daterange = this.formQuery.daterange;
      if (!daterange) {
        this.$message.warning('导出统计数据，需要输入时间');
        return
      }
      const fileName = `统计报表(${moment(daterange[0]).tz(defaultTimeZone).toISOString(true)}到${moment(daterange[1])
          .tz(defaultTimeZone).toISOString(true)}).zip`;
      this.$axios.post('/statistic/order_pack', {daterange: daterange}, {
        responseType: 'blob',
        headers: {
          'Content-Type': "application/json",
        },
      }).then(res => {
        this.$message.info('导出成功');
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      }).catch(res => {
        this.logining = false;
      })
    }
  },
};

</script>

<style>
.user-table-expand {
  font-size: 0;
}

.user-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.user-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.hide-expand .el-table__expand-column .el-icon {
  visibility: hidden;
}
</style>
